export const REDIRECT_URI_PARAM = 'redirect_uri';
export const RESET_TOKEN_PARAM = 'reset_token';
export const PRODUCT_ID_PARAM = 'product';

export const EMPTY_OBJECT = {};
export const NONE = null;

// thread text size tokens
export enum TEXT_SIZE {
  SMALL = '5',
  DEFAULT = '3',
  LARGE = '1',
}
// thread text size tokens
export enum HEADING_SIZE {
  SMALL = '5',
  DEFAULT = '4',
  LARGE = '2',
  XLARGE = '1',
}

export const INTERCOM_SELECTOR_ID = 'intercom-selector';

export enum PRODUCT_ID {
  GENERIC = 'primer',
}

export const DEFAULT_PRODUCT_ID = PRODUCT_ID.GENERIC;

export const VALID_DOMAIN_ENDINGS = ['.primer.ai', '.primering.net'];

export const FORM_ERROR_MESSAGES = {
  EMAIL: {
    REQUIRED: 'Please enter a valid email address.',
  },
  PASSWORD: {
    REQUIRED: 'Please enter a valid password.',
    MIN: 'Password must be at least 9 characters',
    REQUIREMENTS: 'Password does not meet requirements. Please try again.',
    MATCH: 'Passwords do not match. Please try again.',
  },
  FIRST_NAME: {
    REQUIRED: 'Please enter your first name.',
  },
  LAST_NAME: {
    REQUIRED: 'Please enter your last name.',
  },
  CAPTCHA: {
    REQUIRED: 'Please confirm you’re not a robot.',
  },
  COMPANY: {
    REQUIRED: 'Please enter your company name.',
  },
  JOB_TITLE: {
    REQUIRED: 'Please enter your job title.',
  },
};

export const TERMS_URL = 'https://primer.ai/terms-and-conditions';
export const PRIVACY_POLICY_URL = 'https://primer.ai/privacy-policy';
